<div #map class="venue-container"></div>
<div *ngIf="!windowMode" class="flex flex-column venue-map-actions" [ngClass]="{'expanded': isExpanded}">
  <button mat-stroked-button color="primary" class="desktop" *ngIf="authService.checkSalespointProperty('popup_box_office') && !refundMode" (click)="openExternalWindow()">
    {{ 'general.api_sales_customer_screen' | translate }}
  </button>
  <ng-container *ngIf="isRefundMode">
    <div class="heading-5 text-grey align-center desktop">
      {{'general.api_venue_map_refund_actions' | translate}}
    </div>
    <div class="flex flex-grow flex-column-desktop">
      <button mat-flat-button color="primary" (click)="refundModeSave()">
        {{ 'general.api_venue_map_refund_mode_done' | translate }}
      </button>
      <button mat-stroked-button color="primary" (click)="refundModeClear()">
        {{ 'general.api_venue_map_refund_mode_clear' | translate }}
      </button>
    </div>
  </ng-container>
</div>
